export default "__VITE_ASSET__BrIyfZqa__"